import { Skeleton } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import React from "react";

import { COLLAPSED_NAV_ITEM_SIZE, NAV_ITEM_HEIGHT } from "./NavigationBar.consts";

const NavItemSkeleton = ({ open }) => (
  <ListItem sx={{ px: open ? 1.5 : 1, py: 0.5 }}>
    <Skeleton
      variant="rounded"
      height={open ? NAV_ITEM_HEIGHT : COLLAPSED_NAV_ITEM_SIZE}
      width={open ? "100%" : COLLAPSED_NAV_ITEM_SIZE}
      data-testid="navigation-item-skeleton"
    />
  </ListItem>
);

export default NavItemSkeleton;
